export default {
  glow: {
    active: 'Aktiivinen',
    blankText: '(tyhjä)',
    clearAll: 'Tyhjennä kaikki',
    cancel: 'Peruuta',
    close: 'Sulje',
    copied: 'Kopioitu',
    confirm: 'Vahvista',
    copyFailed: 'Kopiointi epäonnistui',
    copyValue: 'Kopioi {{value}}',
    deselectAll: 'Poista valinta',
    dismiss: 'Hylkää',
    event: {
      serviceUpgrade: {
        title: 'Palvelun päivitys',
        curbside: 'Curbside',
        indoor: 'Indorr',
        deliveryDate: 'Toimituspäivämäärä'
      },
      shorterTimeWindow: {
        title: 'Lyhyempi aikaikkuna'
      }
    },
    emptyStates: {
      notFoundTitle: 'Ei tuloksia',
      notFoundDescription: 'Emme löytäneet tuloksia. Säädä hakusuodatintasi ja yritä uudelleen.',
      initialTitle: 'Ei tietoja vielä',
      successTitle: 'Hyvää työtä!'
    },
    filter: 'Suodatin',
    filterOverlay: {
      filter: 'Suodata',
      activeFilterCount: '{{count}} aktiivinen suodatin',
      activeFilterCount_other: '{{count}} aktiivista suodatinta',
      clearFilter: 'Tyhjennä suodatin'
    },
    from: 'Lähtien',
    goToPage: 'Mene sivulle',
    group: 'Ryhmä',
    invalidDateFormat: 'Virheellinen päivämäärämuoto',
    openCalendar: 'Avaa kalenteri',
    loading: 'Lataa',
    no: 'Ei',
    none: 'Ei valintaa',
    notActivated: 'Ei aktivoitu',
    of: '/',
    orderOfTable: 'Sarakeotsikoiden järjestys',
    orderOfTableDescription: 'Valitse haluamasi sarakeotsikoiden järjestys vetämällä ja pudottamalla.',
    fixedTableHeadersDescription:
      'Seuraavat sarakeotsikot ovat kiinteitä, eikä niitä voi poistaa tai järjestää uudelleen.',
    page: 'sivu',
    search: 'Etsi',
    selectAll: 'Valitse kaikki',
    selectAllCount: 'Valitse kaikki ({{count}})',
    selectAllOnPage: 'Valitse kaikki sivulla ({{count}})',
    settings: 'Asetukset',
    to: 'Johonkin',
    yes: 'Kyllä',
    accordionMessage: {
      error: '{{count}} virheviestiä',
      warning: '{{count}} varoitusviestiä',
      info: '{{count}} tietoviestiä',
      general: '{{count}} viestiä'
    },
    invalidRegistrationNumber: 'Anna kelvollinen rekisteröintinumero, joka sisältää vain kirjaimia ja numeroita',
    invalidRegistrationNumber_SE: 'Virheellinen muoto. Odotettu: ABC123 tai ABC12D',
    invalidRegistrationNumber_DK: 'Virheellinen muoto. Odotettu: AB12345',
    invalidRegistrationNumber_NO: 'Virheellinen muoto. Odotettu: AB1234 tai AB12345'
  }
}
